import { Link } from 'react-router-dom';
import { ArrowRightIcon, PhotoIcon } from '@heroicons/react/24/outline';
import { HomeLazySection } from '../HomeLazySection';
import { HomeLookbookCollage } from '../HomeLookbookCollage';
import { homeCta } from '../homeCtaStyles';

export function HomeLookbookSection() {
  return (
    <HomeLazySection
      className="py-12 md:py-16 bg-gradient-to-b from-white via-[#faf9ff] to-white"
      placeholderMinHeight="420px"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white">
              <PhotoIcon className="h-4 w-4" />
              The lookbook
            </p>
            <h2 className="mt-4 text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900">
              Style references,
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#3B3B98] to-[#9B59B6]">
                not stock grids.
              </span>
            </h2>
            <p className="mt-3 text-slate-600 max-w-xl">
              Curated outfit inspiration—swipe more looks or tap to shop the vibe.
            </p>
          </div>

          <Link to="/shop" className={`${homeCta.primary} w-full md:w-auto shrink-0`}>
            Shop the looks
            <ArrowRightIcon className="ml-2 h-4 w-4" />
          </Link>
        </div>

        <div className="mt-6 md:mt-8">
          <HomeLookbookCollage />
        </div>
      </div>
    </HomeLazySection>
  );
}
